import { OpcionCampo } from 'src/app/compartido/formulario/utilidades/formulario.models';
import { EstadoOrden } from './ordenes.models';
import { EstadoDomicilio } from 'src/app/domicilios/utilidades/domicilios.models';

/* Máximo número de órdenes a descargar */
export const MAX_ORDENES_DESCARGA = 50000;

/* Opciones del estado de la orden */
export const OPCIONES_ESTADO_ORDEN: OpcionCampo<EstadoOrden>[] = [
  { nombre: 'Por Preparar', valor: EstadoOrden.POR_PREPARAR },
  { nombre: 'Preparada', valor: EstadoOrden.PREPARADA },
  { nombre: 'Rechazada', valor: EstadoOrden.RECHAZADA },
  { nombre: 'Recogida', valor: EstadoOrden.RECOGIDA },
  { nombre: 'Cancelada', valor: EstadoOrden.CANCELADA },
];

/* Opciones del estado real de la orden */
export const OPCIONES_ESTADO_REAL_ORDEN: OpcionCampo<
  EstadoOrden | EstadoDomicilio
>[] = [
  { nombre: 'Por Preparar', valor: EstadoOrden.POR_PREPARAR },
  { nombre: 'Preparada', valor: EstadoOrden.PREPARADA },
  { nombre: 'Rechazada', valor: EstadoOrden.RECHAZADA },
  { nombre: 'En Bodega', valor: EstadoDomicilio.BODEGA },
  { nombre: 'Ruta Asignada', valor: EstadoDomicilio.RUTA },
  { nombre: 'Despachado', valor: EstadoDomicilio.DESPACHADO },
  { nombre: 'Entregado', valor: EstadoDomicilio.ENTREGADO },
  { nombre: 'Fallido', valor: EstadoDomicilio.FALLIDO },
  { nombre: 'Cancelado', valor: EstadoDomicilio.CANCELADO },
];

/* Estados de orden donde ya fue preparada */
export const ESTADOS_ORDEN_PREPARADA = [
  EstadoOrden.PREPARADA,
  EstadoOrden.RECHAZADA,
  EstadoOrden.RECOGIDA,
];

/* Estados de orden donde hubo error */
export const ESTADOS_ORDEN_ERROR = [
  EstadoOrden.RECHAZADA,
  EstadoOrden.CANCELADA,
];

/* Opciones de tipo de orden */
export const OPCIONES_TIPO_ORDEN: OpcionCampo<string>[] = [
  { nombre: 'Normal', valor: 'normal' },
  { nombre: 'Volumen (Tutelas)', valor: 'volumen' },
];

/* Opciones de prioridad de la orden */
export const OPCIONES_PRIORIDAD_ORDEN: OpcionCampo<string>[] = [
  { nombre: 'Next Day (Siguiente Día)', valor: 'next_day' },
  { nombre: 'Same Day (Mismo Día)', valor: 'same_day' },
  { nombre: 'Express (Urgente)', valor: 'express' },
];
